import React, { Fragment, useCallback, useRef, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import CreateEditGadgets from '../createEditGadgets';
import { HasPermission } from '../../../../../../../../core/security';

// Material UI
import {
    Typography
} from '@mui/material';
// Components
import Modal, { ModalBody } from 'Components/Modal';
import { Button } from 'Components';
// Actions
import {
    openDashboardPanelCreateEditModal,
    sizeDashboardPanelCreateEditModal,
    createGadgetDashboardPanel,
    updateGadgetDashboardPanel,
    clearRedux
} from "Redux/actions";

import { NotificationManager } from "Components/Notifications";
import { GetApiErrorLan } from 'Core/logManager'

import './style.scss';

const CreateEditDashboard = (props) => {
    // Intl
    const { DashboardId } = props;
    const { messages } = useIntl();
    const editCreateDashboardGadgets = useRef();
    const user = useSelector(state => state.securityRedux.user);

    const gadGetsType = [{
        "name": messages['dashboardPanel_edit_title_offline_device'],
        "description": messages['dashboardPanel_edit_description_offline_device'],
        "type": "OfflineDevices"
    },
    {
        "name": messages['dashboardPanel_edit_title_chart'],
        "description": messages['dashboardPanel_edit_description_chart'],
        "type": "Chart"
    },
    {
        "name": messages['dashboardPanel_edit_title_recent_alerts'],
        "description": messages['dashboardPanel_edit_description_recent_alerts'],
        "type": "RecentAlerts"
    },
      {
        "name": messages['dashboardPanel_edit_title_landmark_visit'],
        "description": messages['dashboardPanel_edit_description_landmark_visit'],
        "type": "LandmarkVisit"
      },
      {
        "name": messages['dashboardPanel_edit_title_landmark_real_time'],
        "description": messages['dashboardPanel_edit_description_landmark_real_time'],
        "type": "LandmarkRealTime"
      }];

    // check permission for CARB
    if (HasPermission(user, ["carb"], [317])) {
        gadGetsType.push(
            {
                "name": messages['dashboardPanel_edit_title_emission_check'],
                "description": messages['dashboardPanel_edit_description_emission_check'],
                "type": "EmissionCheck"
            }
        )
    }

    const [selectGadget, setSelectGadget] = useState({});
    //props
    const { callback } = props;
    const urlImagePreview = `/assets/images/`;
    // Hooks
    const dispatch = useDispatch();
    // State local
    const {
        loadingCreateEdit,
        openCreateEdit,
        size_modal,
        gadGet,
        updateResponse,
        createUserGadget,
        errorUserGadget
    } = useSelector((state) => state.dashboardPanelRedux);


    const handleClose = useCallback(() => {
        dispatch(sizeDashboardPanelCreateEditModal('small'));
        dispatch(openDashboardPanelCreateEditModal(false));
        dispatch(clearRedux("DASHBOARD_PANEL", {
            openCreateEdit: false,
            loadingCreateEdit: false,
            updateResponse: false,
            errorUserGadget: null,
            gadGet: {}
        }));
    });

    const returnMain = useCallback(() => {
        if (gadGet.hasOwnProperty('name')) {
            handleClose();
        } else {
            setSelectGadget({})
        }
    });


    const onSubmit = (data) => {
        let settings = JSON.stringify(data);
        let values;
        if (gadGet.hasOwnProperty('name')) {
            values = {
                ...gadGet,
                name: data.name,
                dashboardId: DashboardId,
                settings,
                refreshSeconds: parseInt(data.refreshSeconds)
            };
            dispatch(updateGadgetDashboardPanel(values));
        } else {
            values = {
                ...selectGadget,
                name: data.name,
                dashboardId: DashboardId,
                settings,
                refreshSeconds: parseInt(data.refreshSeconds),
                columnPanel: 1,
                columnOrder: 0
            };
            dispatch(createGadgetDashboardPanel(values));
        }

    };

    useEffect(() => {
        if (createUserGadget?.hasOwnProperty('name')) {
            handleClose();
            NotificationManager.success(
                messages["dashboardPanel_user_gadget_created"],
                messages["dashboardPanel_user_gadget_create_title"],
                4000
            );
        }
    }, [createUserGadget])

    useEffect(() => {
        if (updateResponse?.hasOwnProperty('name')) {
            callback(updateResponse);
            handleClose();
            NotificationManager.success(
                messages["dashboardPanel_user_gadget_edited"],
                messages["dashboardPanel_user_gadget_edit_title"],
                4000
            );
        }
    }, [updateResponse])

    useEffect(() => {
        if (errorUserGadget?.error) {
            NotificationManager.error(
                messages[GetApiErrorLan(errorUserGadget)] || messages["errorMessage"],
                messages["error"],
                4000
            );
        }
    }, [errorUserGadget])

    useEffect(() => {
        if (gadGet.hasOwnProperty('name')) {
            setSelectGadget(gadGet);
        }
    }, [open, gadGet])


    const title = (
        (
            gadGet.hasOwnProperty('name')) ?
            `${messages['dashboardPanel_edit_gadget']} '${gadGet.name}'`
            :
            (messages['dashboardPanel_add_gadget']) + (selectGadget.hasOwnProperty('name') ? ` '${selectGadget.name}'` : "")
    );

    return (
        <Fragment>
            <Modal
                title={title}
                open={openCreateEdit}
                size={size_modal}
                handleClose={() => handleClose()}
                position="right"
                loading={loadingCreateEdit}
                modalTitleStyles={{ fontSize: "1.3rem" }}
                headerStyle={{ paddingTop: "1rem", paddingBottom: "1rem", fontWeight: "bold" }}
            >
                <ModalBody className={'modalCreateEditDashboard'} >
                    <div className={'modalCreateEditDashboard__box'}>
                        {
                            (!selectGadget.hasOwnProperty('name') && gadGetsType?.length) &&
                            gadGetsType.map((gadGetItem, key) => {
                                return (
                                    <div key={key} className="item-gadget-create">
                                        <div style={{ flexBasis: 0, flexGrow: "1" }}>
                                            <img src={`${urlImagePreview}${gadGetItem.type}.png`} style={{ maxWidth: "100%" }} />
                                        </div>
                                        <div style={{ textAlign: 'left', flexBasis: 0, flexGrow: "1" }} >

                                            <Typography variant="body2"
                                                style={{ fontWeight: 700, marginBottom: 5, fontSize: "1.2rem" }}
                                            >
                                                {gadGetItem.name}
                                            </Typography>
                                            <Typography
                                                variant="subtitle2"
                                                style={{ marginBottom: 10, fontSize: "0.9rem" }}
                                            >
                                                {gadGetItem.description}
                                            </Typography>
                                            <Button
                                                onClick={() => {
                                                    setSelectGadget(gadGetItem);
                                                }}
                                                className="btn-blue"
                                                style={{ paddingLeft: "1.5rem", paddingRight: "1.5rem" }}
                                            >
                                                {messages['select']}
                                            </Button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {(selectGadget.hasOwnProperty('name') &&
                            <CreateEditGadgets selectGadget={selectGadget} onSubmit={onSubmit} handleClose={returnMain} />
                        )}

                    </div>
                </ModalBody>

            </Modal>
        </Fragment>
    );
}

export default CreateEditDashboard;
